export default {"src":"/_next/static/media/argument.080e5d0c.svg","height":688,"width":942};